import { isFeatureEnabled } from "./VelocityApi";
import { tryGetHostApi } from "./externalApi";
export async function getHostAuthenticatorApiV2() {
    return (await tryGetHostApi("Authenticator", 2, 2));
}
export async function getHostAuthenticatorApiV3() {
    return (await tryGetHostApi("Authenticator", 3, 3));
}
export async function getHostAuthenticatorApiV4() {
    return (await tryGetHostApi("Authenticator", 4, 4));
}
export async function getHostAuthenticatorApiV5() {
    if (!isFeatureEnabled("Feature_AuthApiV5")) {
        return null;
    }
    return (await tryGetHostApi("Authenticator", 5, 5));
}
export async function getHostAuthenticatorApi(version) {
    return (await tryGetHostApi("Authenticator", version, version));
}
// Deprecated in V5
export async function getDefaultAccountAuthority() {
    const authApi = await getHostAuthenticatorApi(2);
    if (authApi) {
        const accountId = await authApi.getDefaultAccountId();
        if (accountId !== "") {
            return authApi.getAccountProperty(accountId, "ProviderAuthority");
        }
    }
    return "";
}
// Deprecated in V5.
export async function setSignInStatus(signinStatus) {
    const authApi = await getHostAuthenticatorApi(2);
    if (authApi && authApi.setSignInStatus) {
        await authApi.setSignInStatus(signinStatus);
    }
}
// Deprecated in V5
export async function getDefaultAccountType() {
    const accountAuthority = await getDefaultAccountAuthority();
    if (accountAuthority === "") {
        return "NONE";
    }
    else {
        return accountAuthority === "organizations" ? "AAD" : "MSA";
    }
}
/* eslint-enable no-shadow */
// Deprecated in V5
export async function getSignInStatus() {
    const authApi = await getHostAuthenticatorApi(4);
    if (authApi) {
        return await authApi.getSignInStatus();
    }
    return 0 /* Unknown */;
}
// Deprecated in V5
export async function addNewAccountAsync() {
    var _a;
    (_a = getHostAuthenticatorApiV2()) === null || _a === void 0 ? void 0 : _a.then((authApi) => {
        authApi === null || authApi === void 0 ? void 0 : authApi.addNewAccountAsync((accountAdded) => {
            // Dialog was dismissed with either account added or not.
            accountAdded;
        });
    });
}
// Deprecated in V5
export async function getIsAccountAvailable() {
    const authenticatorApiV2 = await getHostAuthenticatorApi(2);
    if (authenticatorApiV2) {
        return await authenticatorApiV2.getIsOnlineAccountAvailable();
    }
    return true; // Return true by default for UX tests
}
export async function addIdentityStatusChangedEventListener(identityStatusChanged) {
    const authenticatorApi = await getHostAuthenticatorApi(2);
    if (authenticatorApi) {
        authenticatorApi.addEventListener("identitystatuschanged", identityStatusChanged);
    }
}
export async function removeIdentityStatusChangedEventListener(identityStatusChanged) {
    const authenticatorApi = await getHostAuthenticatorApi(2);
    if (authenticatorApi) {
        authenticatorApi.removeEventListener("identitystatuschanged", identityStatusChanged);
    }
}
export async function addReauthRequiredStatusChangedEventListener(reauthRequiredStatusChanged) {
    const authenticatorApi = await getHostAuthenticatorApi(3);
    if (authenticatorApi) {
        authenticatorApi.addEventListener("reauthrequiredstatuschanged", reauthRequiredStatusChanged);
    }
}
export async function removeReauthRequiredStatusChangedEventListener(reauthRequiredStatusChanged) {
    const authenticatorApi = await getHostAuthenticatorApi(3);
    if (authenticatorApi) {
        authenticatorApi.removeEventListener("reauthrequiredstatuschanged", reauthRequiredStatusChanged);
    }
}
